var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanityContent = exports.sanitySerializers = exports.renderCode = void 0;
const react_1 = __importDefault(require("react"));
const html_react_parser_1 = __importDefault(require("html-react-parser"));
const node_1 = require("domhandler/lib/node");
const block_content_to_react_1 = __importDefault(require("@sanity/block-content-to-react"));
const gatsby_1 = require("gatsby");
const renderCode = html => {
    const elementId = Math.random()
        .toString(36)
        .substring(9);
    return (0, html_react_parser_1.default)(html, {
        replace: domNode => {
            if (domNode instanceof node_1.Element && domNode.attribs) {
                if (domNode.type === `script`) {
                    let script = document.createElement(`script`);
                    if (domNode.attribs.src)
                        script.src = domNode.attribs.src;
                    // @ts-ignore
                    if (domNode.children.length)
                        script.innerHTML = domNode.children[0].data;
                    script.id = `code-${elementId}`;
                    script.className = `code-${elementId}`;
                    script.type = `text/javascript`;
                    script.async = true;
                    script.defer = true;
                    document.body.prepend(script);
                    return react_1.default.createElement(react_1.default.Fragment, { key: elementId });
                }
            }
            return domNode;
        },
    });
};
exports.renderCode = renderCode;
const serializers = {
    marks: {
        document: ({ children, mark }) => {
            var _a, _b;
            return (react_1.default.createElement(gatsby_1.Link, { to: ((_a = mark === null || mark === void 0 ? void 0 : mark.document) === null || _a === void 0 ? void 0 : _a.link) || "", title: (_b = mark === null || mark === void 0 ? void 0 : mark.document) === null || _b === void 0 ? void 0 : _b.title }, children));
        },
        link: ({ children, mark }) => {
            var _a, _b, _c;
            return (react_1.default.createElement("a", { href: (_a = mark === null || mark === void 0 ? void 0 : mark.link) === null || _a === void 0 ? void 0 : _a.link, title: (_b = mark === null || mark === void 0 ? void 0 : mark.link) === null || _b === void 0 ? void 0 : _b.title, target: ((_c = mark === null || mark === void 0 ? void 0 : mark.link) === null || _c === void 0 ? void 0 : _c.external) ? "_blank" : "" }, children));
        },
        color: ({ children, mark }) => (react_1.default.createElement("span", { style: { color: mark === null || mark === void 0 ? void 0 : mark.hex } }, children)),
    },
    types: {
        code: ({ node }) => (0, exports.renderCode)(node.code),
        image: ({ node }) => { var _a; return react_1.default.createElement("img", { src: (_a = node === null || node === void 0 ? void 0 : node.asset) === null || _a === void 0 ? void 0 : _a.url }); },
        customImage: ({ node }) => { var _a; return react_1.default.createElement("img", { alt: node === null || node === void 0 ? void 0 : node.alt, src: (_a = node === null || node === void 0 ? void 0 : node.asset) === null || _a === void 0 ? void 0 : _a.url }); },
    },
};
const sanitySerializers = customSerializers => ({
    marks: Object.assign(Object.assign({}, serializers === null || serializers === void 0 ? void 0 : serializers.marks), ((customSerializers === null || customSerializers === void 0 ? void 0 : customSerializers.marks) || {})),
    types: Object.assign(Object.assign({}, serializers === null || serializers === void 0 ? void 0 : serializers.types), ((customSerializers === null || customSerializers === void 0 ? void 0 : customSerializers.types) || {})),
});
exports.sanitySerializers = sanitySerializers;
const sanityContent = (content, customSerializers = null) => content ? react_1.default.createElement(block_content_to_react_1.default, { className: "rte", blocks: content, serializers: customSerializers || serializers }) : content;
exports.sanityContent = sanityContent;
//# sourceMappingURL=sanity.js.map